import type { StepType } from "@reactour/tour";
import TourStepContent from "./wrapper";
import { text } from "@quickpoint.me/shared";

const welcome: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11yHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11yIntro}
					</span>
				)}
			/>
		),
		position: "center",
	},
];

export default welcome;
